import React from 'react'
import { Modal } from 'react-bootstrap'
import { t } from 'ttag'
import { Link, Redirect, useHistory } from 'react-router-dom'

const NevadaCaseStudy = ({}) => {
  const history = useHistory()
  const onCancel = () => {
    history.push('/')
  }

  return (
    <Modal show={true} bsSize="lg" onHide={onCancel} dialogClassName="fullscreen-modal">
      <Modal.Body style={{ padding: 0 }}>
        <div className="row" style={{ display: 'flex' }}>
          <div
            className="left-modal-col"
            style={{
              minHeight: '80vh',
              float: 'left',
              width: '30%',
              padding: '25px',
              backgroundColor: '#6a3460'
            }}>
            <h2 style={{ color: 'white', fontWeight: '300', marginBottom: '25px' }}>
              Case Study
            </h2>
            <p style={{ color: 'white' }}>
              How does your library measure the success of its workforce efforts to
              support economic development? How do you know you’re making a real impact on
              providing relevant career information to help to support talent development
              for your regional economies?{' '}
            </p>
            <p style={{ color: 'white', paddingTop: '25px' }}>
              Learn more about the NSLAPR and Headed2 partnership at:
            </p>
            <ul>
              <li style={{ color: 'white' }}>
                <a
                  style={{ color: 'white' }}
                  href="https://nsla.nv.gov/workforce-development1"
                  target="_blank"
                  rel="noreferrer">
                  NSLAPR website
                </a>
              </li>
              <li style={{ color: 'white' }}>
                <a
                  style={{ color: 'white' }}
                  href="https://files.eric.ed.gov/fulltext/ED601682.pdf"
                  target="_blank"
                  rel="noreferrer">
                  John. J. Heldrich Center for Workforce Development
                </a>{' '}
              </li>
              <li style={{ color: 'white' }}>
                <a
                  style={{ color: 'white' }}
                  href="http://www.heldrich.rutgers.edu/sites/default/files/products/uploads/Holcomb_Levandowski.pdf"
                  target="_blank"
                  rel="noreferrer">
                  Rutger’s University
                </a>{' '}
              </li>
              <li style={{ color: 'white' }}>
                <a
                  style={{ color: 'white' }}
                  href="https://risefirst.org/nvprofresources/2018/10/22/nevada-career-explorer"
                  target="_blank"
                  rel="noreferrer">
                  Rise First
                </a>{' '}
              </li>
              <li style={{ color: 'white' }}>
                <a
                  style={{ color: 'white' }}
                  href="https://www.nevadaappeal.com/news/carson-city/nevada-libraries-accelerate-workforce-programs/"
                  target="_blank"
                  rel="noreferrer">
                  Nevada Appeal
                </a>
              </li>
              <li style={{ color: 'white' }}>
                <a
                  style={{ color: 'white' }}
                  href="https://www.frbatlanta.org/cweo/workforce-currents/2020/07/08/public-libraries-and-the-workforce"
                  target="_blank"
                  rel="noreferrer">
                  Federal Reserve Bank Atlanta
                </a>
              </li>
            </ul>
          </div>
          <div
            className="right-modal-col section"
            style={{
              minHeight: '80vh',
              float: 'left',
              width: '70%',
              padding: '25px',
              backgroundColor: '#fff'
            }}>
            <button
              type="button"
              className="close"
              aria-label={t`Close`}
              onClick={onCancel}>
              <span aria-hidden="true" style={{ fontSize: '2rem' }}>
                ×
              </span>
            </button>

            <img
              src={
                '/images/nevada/logo/Logo/Dark/Main/H2-NevadaCareerExplorer-Logo-0119_MainDark.svg'
              }
              style={{ maxWidth: '50%', marginBottom: '25px' }}
            />

            <p>
              In 2018, the Nevada State Library Archive & Public Records (NSLAPR) sought
              to make the ultimate Career Readiness database and platform available to
              library card holders throughout the State. With the CareerExplorer powered
              by Headed2, the NSLAPR found a solution that fits their workforce
              development services by combining custom features, including sign-in using a
              unique library card identifier and spotlighting the state’s high priority
              industry sectors and in-demand occupations with the the CareerExplorer’s
              already robust self-assessment and career exploration engine.
            </p>

            <p>
              After just six months the site reached important patron usage milestones,
              gaining incredible traction with thousands of monthly active users, and
              acclaim from the Institute of Museum and Library Services. The Nevada
              CareerExplorer is impacting lives throughout Nevada, helping individuals
              find careers that are right for them.
            </p>

            <p>
              At Headed2 we know that what Economic Development Agencies, Workforce
              Investment Boards and industry associations need is not just another
              marketing site to sustain, grown and retain talent to fuel their regional
              economies...what they need is a fully functioning career readiness tool that
              has the power to transform the emerging and existing workforce with a proven
              record of generating large, diversified and engaged audiences.
            </p>

            <p>
              <b>
                If you’re interested in learning more about sponsoring a CareerExplorer
                platform in your community:
              </b>
              <br className="clear" />
              <Link
                to={'/quote'}
                className="btn btn-success btn-lg navbar-btn pull-right">
                Contact Us
              </Link>
            </p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export { NevadaCaseStudy }
